const pad = (n) => String(n).padStart(2, '0');

const todayKey = (now) => `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;

/**
 * Client links only open published packages still on sale (mirrors
 * partnerPlanService.publishedOnSaleSql), whether marketplace or private.
 */
export function isPackageShareable(pkg, now = new Date()) {
  if (!pkg || pkg.status !== 'published') return false;
  if (!pkg.available_until) return true;
  const until = String(pkg.available_until).slice(0, 10);
  return until >= todayKey(now);
}

export default isPackageShareable;
